import React from 'react';
import SEO from "../Component/SEO";
import './career.css';
import Code from './Code';
import Section from './Section';
import Recognised from './Recognised';
import Carousel from './Carousel';
import Formjob from './Formjob';
import ClientSpeack from './ClientSpeack';
import Gfooter from '../Component/Gfooter';
import ClientSpeackData from '../Component/ClientSpeackData';



function Add() {
  return (
    <div className='career-top'>

      <SEO
        title="NLF Careers & Job Opportunities | NLF Solutions"
        description="Explore career opportunities and job openings at NLF Solutions. Join our team and build your career in architectural products and solutions."
        canonical="https://nlfs.in/careers"
        keywords="NLFS Careers, NLFS Jobs, Careers at NLF Solutions, NLF Solutions Careers, Jobs at NLF Solutions, NLF Job Openings, NLF Vacancies, Career Opportunities at NLF, Join NLF Solutions, Work at NLF Solutions, Job Opportunities in NLF, NLF Solutions careers in India, NLF Solutions job openings, NLF Solutions vacancies, jobs at NLF Solutions, career opportunities at NLF Solutions, architectural solutions company jobs, jobs in architectural products industry, career opportunities in architectural solutions"
      />
      <h1 className="seo-h1">Careers at NLF Solutions</h1>

      <Code />
      <Carousel />
      <Section />
      <Formjob />
      <Gfooter />
    </div>
  );
}

export default Add;